import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'black-accordion-content',
    templateUrl: './accordion-content.component.html',
    styleUrls: ['./accordion-content.component.css'],
    standalone: false
})
export class AccordionContentComponent {
  @Input()
  resourceItems = [
    {
      id: '',
      icon: '',
      link: '',
      type: '',
      title: '',
    },
  ];

  @Input()
  modelId = 0;

  @Output()
  deleteEvent = new EventEmitter<string>();

  onDelete(resourceId: string) {
    this.deleteEvent.emit(resourceId);
  }
}
